import MiniLazyload from "minilazyload";

export default () => {
  let lazyLoad = new MiniLazyload({ rootMargin: "200px" }, ".lazyload");

  if (document.querySelector(".js-tabs")) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lazyLoad = new MiniLazyload({ rootMargin: "500px", threshold: 0.5 }, ".lazyload");
  }
};
